/** Display-only projection. It never advances an operation or treats a frame event as settlement. */
export function fundingOperationPresentation(operation) {
    if (operation.status === 'failed' ||
        operation.status === 'cancelled' ||
        operation.status === 'refunded')
        return { phase: operation.status, timeline: false, stages: ['pending', 'pending', 'pending'] };
    const confirmed = operation.status === 'delivered' &&
        operation.settlementEvidence === 'provider_reported' &&
        operation.walletDelivery?.state === 'confirmed';
    if (confirmed)
        return { phase: 'complete', timeline: true, stages: ['complete', 'complete', 'complete'] };
    if (operation.status === 'delivered' &&
        operation.settlementEvidence === 'provider_reported' &&
        operation.walletDelivery?.state === 'sandbox_confirmed')
        return {
            phase: 'sandbox_complete',
            timeline: true,
            stages: ['complete', 'complete', 'complete'],
        };
    if (operation.status === 'delivered' && operation.settlementEvidence === 'provider_reported')
        return { phase: 'processing', timeline: true, stages: ['complete', 'complete', 'loading'] };
    if (operation.status === 'processing' || operation.status === 'delivered')
        return { phase: 'processing', timeline: true, stages: ['complete', 'loading', 'pending'] };
    return { phase: 'unknown', timeline: true, stages: ['loading', 'pending', 'pending'] };
}
/** Retained quote values are display estimates, never delivery evidence or payment authority. */
export function fundingOperationAmounts(operation, quoted) {
    if ('cryptoDepositSource' in operation || 'connectedWalletSource' in operation)
        return {
            chargedUnits: null,
            feeUnits: null,
            receivedD6: operation.receivedD6 ?? operation.walletDelivery?.receivedUnits ?? null,
        };
    if ('exchangeSource' in operation)
        return {
            chargedUnits: null,
            feeUnits: null,
            receivedD6: operation.walletDelivery?.receivedUnits ?? operation.receivedD6,
        };
    const estimate = quoted?.review.estimate;
    const matches = quoted?.operationId === operation.id &&
        estimate?.currency === operation.fiatCurrency &&
        estimate?.decimals === operation.fiatDecimals &&
        estimate?.principalUnits === operation.principalUnits;
    const persisted = operation.quotedAmounts;
    return {
        chargedUnits: operation.chargedUnits ??
            persisted?.totalUnits ??
            (matches ? (estimate?.totalUnits ?? null) : null),
        feeUnits: operation.feeUnits ?? persisted?.feeUnits ?? (matches ? (estimate?.feeUnits ?? null) : null),
        receivedD6: (operation.destinationAsset === 'USDC_SOL'
            ? operation.walletDelivery?.receivedUnits
            : null) ??
            operation.receivedD6 ??
            (operation.destinationAsset === 'USDC_SOL' ? persisted?.receivedUnits : null) ??
            (matches && operation.destinationAsset === 'USDC_SOL'
                ? (quoted?.review.receivedUnits ?? null)
                : null),
    };
}
